import { handleActions } from 'redux-actions';
import { ModerationState } from './types';
import { reduxKey } from './constants';
import {
  blockUserSuccess,
  unblockUserSuccess,
} from '../../redux/users/actionCreators';
import { hideDeviationSuccess, unhideDeviationSuccess } from './actions';

const actionHandlers = handleActions<ModerationState, any>(
  {
    [blockUserSuccess.toString()]: (
      state,
      { payload: userId }: ReturnType<typeof blockUserSuccess>
    ) => ({
      ...state,
      users: {
        ...state.users,
        [userId]: {
          isBlocked: true,
        },
      },
    }),
    [unblockUserSuccess.toString()]: (
      state,
      { payload: userId }: ReturnType<typeof unblockUserSuccess>
    ) => ({
      ...state,
      users: {
        ...state.users,
        [userId]: {
          isBlocked: false,
        },
      },
    }),
    [hideDeviationSuccess.toString()]: (
      state,
      { payload: deviationId }: ReturnType<typeof hideDeviationSuccess>
    ) => ({
      ...state,
      deviations: {
        ...state.deviations,
        [deviationId]: {
          isBlocked: true,
        },
      },
    }),
    [unhideDeviationSuccess.toString()]: (
      state,
      { payload: deviationId }: ReturnType<typeof unhideDeviationSuccess>
    ) => ({
      ...state,
      deviations: {
        ...state.deviations,
        [deviationId]: {
          isBlocked: false,
        },
      },
    }),
  },
  { users: {}, deviations: {} }
);

export default {
  [reduxKey as string]: actionHandlers,
};
